module.exports = __webpack_public_path__ + "static/media/message-box-survey.518bdd94.png";